import type { SYSTableDef } from "../../../../../../_ovlclient/src/library/table/tableapi"

export let tblSymbolPC: SYSTableDef = {
  id: "SPCSymbolPC",
  permission: "SPCSP",
  database: {
    dataIdField: "Code",
    dbInsertMode: "UDTAutoGUIDBoth",
  },
  server: {
    endpoint: "symbolpc",
  },
  title: { dialogTitle: { doNotDisplayId: true } },
  options: {
    initial_sort: { field: "U_Customer", direction: "asc" },
    initial_paging: { page: 0, pageSize: 200 },
    labelAndColumnTitleHandling: { translationPrefix: "SPCSymbolPCCol" },
  },

  features: {
    page: true,

    add: true,
    edit: true,
    delete: true,
  },
  columns: {
    U_CardCode: {
      sortable: true,
      list: {
        lookupDefKey: "OCRD",
        valueField: "CardCode",
        displayField: "CardName",
        serverEndpoint: "data/lookups/cardcode",
      },
      ui: { displayEmptyIfValue: "---" },
      schema: { nullable: false },
    },
    U_DescAdmin: {
      sortable: true,
    },
    U_Desc: {
      sortable: true,
      ui: { alwaysReadOnly: true },
    },
    U_Id: {
      ui: { alwaysReadOnly: true },
    },
    U_LastChecked: {
      type: "date",
      sortable: true,
      ui: {
        format: "timestamp",
        visibility: "Table",
      },
    },

    U_ValidTo: {
      type: "date",
      sortable: true,
      ui: {
        useBrowserDatePicker: true,
      },
    },
  },
}
